import { computed, get, defineProperty } from '@ember/object';
import { getOwner } from '@ember/application';
import { assert } from '@ember/debug';

// For this function, Ember has no type definition with an arbitrary number of string parameters followed by a function,
// since JS/TS only allow the rest parameter to be last in the list (not first),
// so we have to add our own type definition allowing any number of arbitrary parameters.
// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * @private
 * @hide
 */
export const __serviceInjectionName = `features-${Date.now().toString(36)}`;
function addPrefixToStrings(strings, prefix) {
  return strings.map(str => `${prefix}${str}`);
}

/**
 * This is a wrapper used to provide computed property macros with access to the injected features service.
 * The implementation is based on the `t` computed property macro from ember-intl.
 */
export default function macroServiceWrapper(getterFn, dependentKeys = []) {
  const dependentKeysWithServiceName = addPrefixToStrings(['_isSetup', ...dependentKeys], `${__serviceInjectionName}.`);
  return computed(...dependentKeysWithServiceName, function (propertyKey) {
    if (!get(this, __serviceInjectionName)) {
      const owner = getOwner(this);
      assert(`Attempted to define a feature flag macro computed property called '${propertyKey}' on an object/class that was instantiated without an owner (use 'setOwner', or 'wrapWithOwner' in Dashboard legacy tests).`, owner);
      defineProperty(this, __serviceInjectionName, {
        value: owner.lookup('service:features'),
        enumerable: false
      });
    }
    const service = get(this, __serviceInjectionName);
    return getterFn.call(this, service, propertyKey);
  }).readOnly();
}